import { GroupDto, GroupsApi } from '../../../api-client';
import { ErrorResponse } from '../../../common/types/errorRespose';
import { useQuery, UseQueryResult } from 'react-query';

const QUERY_KEY = 'groups';

export const useGetGroups = (
  groupsApi: GroupsApi,
  tenantId: string,
  onError: (err: ErrorResponse) => void,
): UseQueryResult<GroupDto[]> =>
  useQuery(
    [QUERY_KEY],
    async () => groupsApi.listGroups(tenantId, undefined, undefined, 99999).then((res) => res.data),
    {
      keepPreviousData: false,
      retry: false,
      onError,
    },
  );
